import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import Basics from "./Basics";
import Brands from "./Brands";
import Dashbord from "./Dashbord";
import Products from "./Products";
import { stringConstants } from "../../../helpers/app-constants";
import UsersList from "./UsersList";
import ServiceTaxDetails from "./ServiceTaxDetails";
import BasicInformation from "../common/BasicInformation";
import AcceptedOrders from "../AdminPanelSeller/AcceptedOrders";
import AcceptedEnquiries from "../AdminPanelSeller/AcceptedEnquiries";
import UserDetails from "./UsersList/UserDetails";
import ReferralHistory from "./ReferralHistory";

const AdminPanelBharee = ({ currentView, scrollRef, currentViewId, currentViewObj }) => {
  switch (currentView) {
    case stringConstants.DASHBOAD:
      return <Dashbord scrollRef={scrollRef} />;
      case stringConstants.REFERRAL_HISTORY:
  return <ReferralHistory />;
    case stringConstants.MY_ENQUIRIES:
      return <AcceptedEnquiries enquiryStatus={"accepted"} title={"Accepted Enquiries"} />;
    case stringConstants.MY_ORDERS:
      return (
        <div className="mt-4">
          <div className="mb-4">
            <AcceptedOrders orderStatus={"accepted"} title={"Accepted Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders
              orderStatus={"shipped"}
              title={"Orders Assigned to LP & Not Accepted"}
            />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"lpaccepted"} title={"LP Accepted Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"outfordelivery"} title={"Out for Delivery Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"delivered"} title={"Delivered Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"cancelled"} title={"Cancelled Orders"} />
          </div>
          <div className="mb-4">
            <AcceptedOrders orderStatus={"rejected"} title={"Rejected Orders"} />
          </div>
        </div>
      );
    case stringConstants.REPORTS:
      return (
        <Container>
          {"Report will appear and also download or export reports will be here"}
        </Container>
      );
    case stringConstants.BRANDS:
      return <Brands />;
    case stringConstants.PRODUCTS:
      return <Products />;
    case stringConstants.BASICS:
      return <Basics />;
    case stringConstants.USER_SELLERS:
      return <UsersList roleType={"seller"} />;
    case stringConstants.USER_BUYERS:
      return <UsersList roleType={"buyer"} />;
    case stringConstants.USER_EMPLOYEES:
      return <UsersList roleType={"employee"} />;
    case stringConstants.USER_LP:
      return <UsersList roleType={"logistic_partner"} />;
    case stringConstants.SERVICE_TAX_DETAILS:
      return <ServiceTaxDetails />;
    case stringConstants.BASIC_INFORMATION:
      return <BasicInformation />;
    case stringConstants.USER_DETAILS:
      return <UserDetails userId={currentViewId} userObj={currentViewObj} />;

    default:
      return <Container>{"work in process.."}</Container>;
  }
};

export default AdminPanelBharee;
